import React, { useEffect, useState, useMemo } from "react";
import * as Mui from "@mui/material";
import { themes, yearMonth } from "services/constants";
import { useForm } from "react-hook-form";
import {
  minimum3Characters,
  minimum10Digits,
} from "services/constants/ErrorMessages";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { CustomTextBox } from "components/CustomComponents/CustomTextBox";
import moment from "moment";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import {
  specialCharacterRestrict,
  onlyNumberRegex,
  specialCharacterRest,
} from "services/constants/patterns";

import { CustomButton } from "components/CustomComponents/CustomButton";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { useFetch } from "services/hooks/useFetch";
import { useSelector, useDispatch } from "react-redux";
import { setScreenUserId, setEditPage } from "services/Redux/HRPortal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { customAPI } from "services/utils/CustomAPI";
import { Info } from "@mui/icons-material";
import { tooltipStyleProps } from "services/constants/Styles";

export const BasicInfo = ({ onFieldCheck }) => {
  const initialValues = useMemo(
    () => ({
      company: "",
      date_joined: moment(new Date()).format("YYYY-MM-DD"),
      departmentName: "",
      designation: "",
      email: "",
      employee_id: "",
      employmentType: "",
      leaveGroup: "",
      leaveGroupCount: "",
      phone_number: "",
      shiftCatgName: "",
      shiftGradeName: "",
      user_name: "",
    }),
    [],
  );
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    clearErrors,
    unregister,
    formState: { errors },
  } = useForm({ defaultValues: initialValues });
  const watchAllFields = watch();
  const history = useHistory();
  const dispatch = useDispatch();
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const [checkBoxValue, setCheckBoxValue] = useState(false);
  const { result: lastInsertedEmployeeId } = useFetch(
    `${domain}employee-id/last-used`,
  );
  //Text and autocomplete States
  const [userId, setUserId] = useState(0);
  const [userNameDetails, setUserNameDetails] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [shiftGradeName, setShiftGradeName] = useState("");
  const [shiftCatgName, setShiftCatgName] = useState("");
  const [shiftGroupName, setShiftGroupName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [dateOfJoining, setDateOfJoining] = useState(
    moment(new Date()).format(yearMonth),
  );
  const [updateDate, setUpdateDate] = useState(true);
  const [employeeId, setEmployeeId] = useState("");
  const [leaveGroupName, setLeaveGroupName] = useState("");
  const [employmentTypeName, setEmploymentTypeName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const { result: department } = useFetch(`${domain}department/`);
  const { result: designation } = useFetch(`${domain}designation/`);
  const { result: employmentType } = useFetch(`${domain}employment-type/`);
  const { result: userGroup } = useFetch(`${domain}leave-groups-basics/`);
  const { result: companyList } = useFetch(`${domain}get-active-company/`);
  const { result: shiftGradeData } = useFetch(
    `${domain}administration/shiftroster/shiftgrade/shift-grades/`,
  );
  const { result: shiftGroupData } = useFetch(
    `${domain}administration/shiftroster/shiftgroups/shift-groups/`,
  );
  const { result: shiftCatgList } = useFetch(
    `${domain}administration/shiftroster/shiftrota/shift-categories?status=Active`,
  );
  const { result: userGroupList } = useFetch(
    `${domain}basic/user-group/details/`,
  );

  let multipleCallRestriction = true;

  useEffect(() => {
    const hasChanged = Object.keys(initialValues).some(
      (key) => watchAllFields[key] !== initialValues[key],
    );
    onFieldCheck(hasChanged);
  }, [initialValues, onFieldCheck, watchAllFields]);

  useEffect(() => {
    if (updateDate) {
      setValue("date_joined", moment(new Date()).format(yearMonth));
      setUpdateDate(false);
    }
  }, [setValue, updateDate]);

  const updateUserName = (event) => {
    if (
      specialCharacterRestrict.test(event.target.value) &&
      event.target.value.length <= 32
    ) {
      setUserNameDetails(event.target.value);
      setValue("user_name", event.target.value);
    }
  };

  const handleEmployeeId = (event) => {
    if (
      specialCharacterRest.test(event.target.value) &&
      event.target.value.length <= 12
    ) {
      setValue("employee_id", event.target.value);
      setEmployeeId(event.target.value);
    }
  };

  const handleCompanyName = (event, data) => {
    if (data) {
      setValue("company", data?.label);
      setValue("company_id", data?.id);
      setCompanyName(data?.label);
    } else {
      setValue("company", "");
      setValue("company_id", null);
      setCompanyName("");
    }
  };
  const handleDepartment = async (event, data) => {
    if (data) {
      setValue("departmentName", data?.label);
      setValue("department_id", data?.id);
      setDepartmentName(data?.label);

      // setValue("shiftGradeName", "");
      // setValue("shift_grade", null);
      // setValue("shiftCatgName", "");
      // setValue("shift_category", null);
      // setShiftGradeName("");
      // setShiftCatgName("");
    } else {
      setValue("departmentName", "");
      setValue("department_id", null);
      setDepartmentName("");
      // setValue("shiftGradeName", "");
      // setValue("shift_grade", null);
      // setValue("shiftCatgName", "");
      // setValue("shift_category", null);
      // setShiftGradeName("");
      // setShiftCatgName("");
    }
  };

  const handleShiftGradeName = (event, data) => {
    if (data) {
      setValue("shiftGradeName", data?.label);
      setValue("shift_grade", data?.id);
      setShiftGradeName(data?.label);
      setValue("shiftCatgName", "");
      setValue("shift_category", null);
      setValue("shiftGroup", "");
      setShiftGroupName("");
    } else {
      setValue("shiftGradeName", "");
      setValue("shift_grade", null);
      setShiftGradeName("");
      setValue("shiftCatgName", "");
      setValue("shift_category", null);
    }
  };

  const handleShiftCatgName = (event, data) => {
    if (data) {
      setValue("shiftCatgName", data?.label);
      setValue("shift_category", data?.id);
      setShiftCatgName(data?.label);
    } else {
      setValue("shiftCatgName", "");
      setValue("shift_category", null);
      setShiftCatgName("");
    }
  };

  const handleDesignation = (event, data) => {
    if (data) {
      setValue("designation", data?.label);
      setValue("designation_id", data?.id);
      setDesignationName(data?.label);
    } else {
      setValue("designation", "");
      setValue("designation_id", null);
      setDesignationName("");
    }
  };

  const handleDateOfJoined = (event) => {
    setValue("date_joined", event.target.value);
    setDateOfJoining(event.target.value);
  };

  const handleEmploymentType = (event, data) => {
    if (data) {
      setValue("employmentType", data?.label);
      setValue("employment_type_id", data?.id);
      setEmploymentTypeName(data?.label);
    } else {
      setValue("employmentType", "");
      setValue("employment_type_id", null);
      setEmploymentTypeName("");
    }
  };

  const handleUserLeaveGroup = (event, data) => {
    if (data) {
      setValue("leaveGroup", data?.label);
      setValue("leave_group_id", data?.id);
      setValue("leaveGroupCount", data?.overall_leave_count);
      setLeaveGroupName(data?.label);
    } else {
      setValue("leaveGroup", "");
      setValue("leave_group_id", null);
      setValue("leaveGroupCount", 0);
      setLeaveGroupName("");
    }
  };

  const updateCheckBoxValue = (event) => {
    setCheckBoxValue(event.target.checked);
    setValue("usergroup_name", "");
    setValue("user_group", "");
    if (!event.target.checked) {
      clearErrors("usergroup_name");
      unregister("usergroup_name");
    }
  };

  const updatePhoneNumber = (event) => {
    if (
      event.target.value.length <= 15 &&
      onlyNumberRegex.test(event.target.value)
    ) {
      setPhoneNumber(event.target.value);
      setValue("phone_number", event.target.value);
    }
  };

  const onSubmit = async (data) => {
    if (multipleCallRestriction) {
      setButtonLoader(true);
      multipleCallRestriction = false;
      const payload = {
        ...data,
        user_name: data?.user_name.trim(),
        portal_access: checkBoxValue,
      };
      const response = await customAPI(
        `${domain}employee-onboard`,
        "POST",
        payload,
      );
      if (response.ok) {
        setUserId(response.responseDetails.user_id);
        showToast("success", "Employee details created successfully");
        setOpenDialog(true);
        setButtonLoader(false);
        multipleCallRestriction = true;
      } else {
        multipleCallRestriction = false;
        setButtonLoader(false);
      }
    }
  };

  const handleShiftGroup = (event, data) => {
    if (data) {
      setValue("shiftGroup", data?.label);
      setValue("shift_group", data?.id);
      setShiftGroupName(data?.label);
    }
  };

  const handleUserGroupName = (event, data) => {
    if (data) {
      setValue("usergroup_name", data?.label);
      setValue("user_group", data?.id);
    } else {
      setValue("usergroup_name", "");
      setValue("user_group", "");
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid
        container
        sx={{
          padding: { xs: 0.4, sm: 0.4, md: 0.4, lg: 0.6, xl: 1, xxl: 1 },
        }}
      >
        <Mui.Typography
          sx={{
            fontSize: 20,
            fontWeight: "bold",
            color: themes.headLine,
            paddingLeft: 1,
          }}
        >
          Basic Informations
        </Mui.Typography>
      </Mui.Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid
          container
          sx={{
            border: `1px solid ${themes.sidebarDivider}`,
            borderRadius: 3,
            paddingBottom: 1,
          }}
        >
          <Mui.Grid container>
            <Mui.Grid container sx={{ paddingTop: 0.3 }}>
              <Mui.Grid xs={0.9} sx={{ padding: 1 }}>
                <Mui.Typography
                  sx={{
                    fontSize: 15,
                    color: themes.headLine,
                    paddingTop: 1,
                    fontWeight: "bold",
                  }}
                >
                  Company &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Select the company the employee is assigned to."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.2}></Mui.Grid>
              <Mui.Grid xs={3.3} sx={{ padding: 1 }}>
                <CustomAutoComplete
                  dataList={companyList.map((obj) => ({
                    ...obj,
                    label: obj.companyname,
                  }))}
                  selectedValue={companyName}
                  rules={{
                    ...register("company", {
                      required: "Company name is required",
                    }),
                  }}
                  updateDataFunction={handleCompanyName}
                  placeHolder="Select the company name"
                  errorMessage={
                    errors?.company?.message ? errors?.company?.message : ""
                  }
                  textBoxError={errors.company ? true : false}
                />
              </Mui.Grid>
            </Mui.Grid>

            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Name &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the employee’s full name."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={userNameDetails}
                rules={{
                  ...register("user_name", {
                    required: "Username is required",
                    maxLength: {
                      value: 32,
                      message: "Maximum 32 characters are required",
                    },
                    validate: {
                      minLengthNoSpaces: (value) => {
                        if (value?.trim().length < 3 && value !== "") {
                          return minimum3Characters;
                        } else {
                          return true;
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updateUserName}
                placeHolder="Enter the name"
                errorMessage={
                  errors?.user_name?.message ? errors?.user_name?.message : ""
                }
                textBoxError={errors.user_name ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Grid container>
                <Mui.Grid xs={5}>
                  <Mui.Typography
                    sx={{
                      fontSize: 15,
                      color: themes.headLine,
                      paddingBottom: 0.5,
                      fontWeight: "bold",
                    }}
                  >
                    Employee ID &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Assign or enter a unique employee ID. (Last used: ghh4t654)"
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid
                  xs={7}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <Mui.Typography
                    sx={{
                      // color: themes.darkPrimaryColor,
                      fontSize: 15,
                      fontWeight: 700,
                    }}
                  >
                    Last Used : {lastInsertedEmployeeId.latest_employee_id}
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
              <CustomTextBox
                selectedValue={employeeId}
                rules={{
                  ...register("employee_id", {
                    required: "Employee id is required",
                    minLength: {
                      value: 6,
                      message: "Minimum 6 characters are required",
                    },
                    validate: {
                      minLengthNoSpaces: (value) => {
                        if (value?.trim().length < 3 && value !== "") {
                          return minimum3Characters;
                        } else {
                          return true;
                        }
                      },
                      employeeIdAvailable: async (fieldValue) => {
                        if (fieldValue !== "") {
                          const response = await fetch(
                            `${domain}employee-id/check?employee_id=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "Employee id already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={handleEmployeeId}
                placeHolder="Enter the employee id"
                errorMessage={
                  errors?.employee_id?.message
                    ? errors?.employee_id?.message
                    : ""
                }
                textBoxError={errors.employee_id ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Date of Joining &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Choose the employee’s official joining date."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                type="date"
                selectedValue={dateOfJoining}
                rules={{
                  ...register("date_joined", {
                    required: "Date of joined is required",
                  }),
                }}
                updateDataFunction={handleDateOfJoined}
                errorMessage={
                  errors?.date_joined?.message
                    ? errors?.date_joined?.message
                    : ""
                }
                textBoxError={errors.date_joined ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Phone Number &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter a valid contact number for internal communication."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomTextBox
                selectedValue={phoneNumber}
                rules={{
                  ...register("phone_number", {
                    required: "Phone number is required",
                    minLength: {
                      value: 10,
                      message: minimum10Digits,
                    },
                    validate: {
                      employeePhonenumberAvailable: async (fieldValue) => {
                        if (fieldValue !== "") {
                          const response = await fetch(
                            `${domain}unique/phone-number/?phone_no=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const resp = await response.json();
                          if (resp.exists) {
                            return "Phone number already exists";
                          }
                        }
                      },
                    },
                  }),
                }}
                updateDataFunction={updatePhoneNumber}
                placeHolder="Enter the phone number"
                errorMessage={
                  errors?.phone_number?.message
                    ? errors?.phone_number?.message
                    : ""
                }
                textBoxError={errors.phone_number ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Email Id &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Provide a corporate or personal email address."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <Mui.TextField
                size="small"
                {...register("email", {
                  required: false,
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid e-mail address",
                  },
                  validate: {
                    emailAvailable: async (fieldValue) => {
                      if (fieldValue !== "") {
                        try {
                          const response = await fetch(
                            `${domain}unique/email/?email=${fieldValue}`,
                            {
                              method: "GET",
                              headers: {
                                "Content-Type": "application/json",
                                Authorization: `token ${token}`,
                              },
                            },
                          );
                          const res = await response.json();
                          if (response.ok) {
                            if (res.exists) {
                              return "Email already exists";
                            } else {
                              return true;
                            }
                          } else if (response.status === 409) {
                            sessionHandling();
                          } else {
                            throw new Error(res.error);
                          }
                        } catch (error) {
                          showToast("error", error.message);
                        }
                      }
                    },
                  },
                })}
                error={Boolean(errors.email)}
                helperText={errors.email ? errors.email.message : null}
                placeholder="Enter the email"
                fullWidth
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Employment Type &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Choose between full-time, part-time, intern, etc."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={employmentType.map((obj) => ({
                  ...obj,
                  label: obj.employment_type,
                }))}
                selectedValue={employmentTypeName}
                rules={{
                  ...register("employmentType", {
                    required: "Employment type is required",
                  }),
                }}
                updateDataFunction={handleEmploymentType}
                placeHolder="Select the employment type"
                errorMessage={
                  errors?.employmentType?.message
                    ? errors?.employmentType?.message
                    : ""
                }
                textBoxError={errors.employmentType ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Department &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Assign the employee to a department."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={department.map((obj) => ({
                  ...obj,
                  label: obj.department,
                }))}
                selectedValue={departmentName}
                rules={{
                  ...register("departmentName", {
                    required: "Department name is required",
                  }),
                }}
                updateDataFunction={handleDepartment}
                placeHolder="Select the department name"
                errorMessage={
                  errors?.departmentName?.message
                    ? errors?.departmentName?.message
                    : ""
                }
                textBoxError={errors?.departmentName ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Designation &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Select their role/title within the organization."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={designation.map((obj) => ({
                  ...obj,
                  label: obj.designation,
                }))}
                selectedValue={designationName}
                rules={{
                  ...register("designation", {
                    required: "Designation is required",
                  }),
                }}
                updateDataFunction={handleDesignation}
                placeHolder="Select the designation"
                errorMessage={
                  errors?.designation?.message
                    ? errors?.designation?.message
                    : ""
                }
                textBoxError={errors?.designation ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Leave Group &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Allocate a leave group to define entitlements and policies. "
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={userGroup.map((obj) => ({
                  ...obj,
                  label: obj.name,
                }))}
                selectedValue={leaveGroupName}
                rules={{
                  ...register("leaveGroup", {
                    required: "Leave group is required",
                  }),
                }}
                updateDataFunction={handleUserLeaveGroup}
                placeHolder="Select the leave group"
                errorMessage={
                  errors?.leaveGroup?.message ? errors?.leaveGroup?.message : ""
                }
                textBoxError={errors?.leaveGroup ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Shift Grade &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Set the employee's shift grade for time tracking and pay."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={shiftGradeData.map((obj) => ({
                  ...obj,
                  label: obj.name,
                }))}
                selectedValue={shiftGradeName}
                rules={{
                  ...register("shiftGradeName", {
                    required: "Shift grade is required",
                  }),
                }}
                updateDataFunction={handleShiftGradeName}
                placeHolder="Select the shift grade"
                errorMessage={
                  errors?.shiftGradeName?.message
                    ? errors?.shiftGradeName?.message
                    : ""
                }
                textBoxError={errors?.shiftGradeName ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Shift Group &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Assign the appropriate shift group based on scheduling. "
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={shiftGroupData.map((obj) => ({
                  ...obj,
                  label: obj.name,
                }))}
                selectedValue={shiftGroupName}
                rules={{
                  ...register("shiftGroup", {
                    required: "Shift Group is required",
                  }),
                }}
                updateDataFunction={handleShiftGroup}
                placeHolder="Select the shift group"
                errorMessage={
                  errors?.shiftGroup?.message ? errors?.shiftGroup?.message : ""
                }
                textBoxError={errors?.shiftGroup ? true : false}
              />
            </Mui.Grid>
            <Mui.Grid xs={4} sx={{ padding: 1 }}>
              <Mui.Typography
                sx={{
                  fontSize: 15,
                  color: themes.headLine,
                  paddingBottom: 0.5,
                  fontWeight: "bold",
                }}
              >
                Shift Category &nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Select the shift category based on the given shift category. "
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
              <CustomAutoComplete
                dataList={shiftCatgList.map((obj) => ({
                  ...obj,
                  label: obj.name,
                }))}
                selectedValue={shiftCatgName}
                rules={{
                  ...register("shiftCatgName", {
                    required: "Shift Category name is required",
                  }),
                }}
                updateDataFunction={handleShiftCatgName}
                placeHolder="Select the shift category"
                errorMessage={errors?.shiftCatgName?.message || ""}
                textBoxError={!!errors?.shiftCatgName}
              />
            </Mui.Grid>
          </Mui.Grid>

          <Mui.Grid
            container
            sx={{
              paddingBottom: { xs: 2, sm: 4, md: 4, lg: 5, xl: 5, xxl: 5 },
            }}
          />

          <Mui.Grid
            container
            alignItems="center"
            spacing={2}
            style={{ paddingLeft: 5, paddingRight: 5 }}
          >
            <Mui.Grid item xs={12} md={2}>
              <Mui.Typography
                sx={{
                  fontSize: 20,
                  fontWeight: "bold",
                  color: themes.headLine,
                  paddingLeft: 1,
                }}
              >
                Enable Portal Access
              </Mui.Typography>
            </Mui.Grid>

            <Mui.Grid
              item
              xs={2}
              md="auto"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Mui.FormControlLabel
                control={
                  <Mui.Checkbox
                    checked={checkBoxValue}
                    color="primary"
                    size="large"
                    onChange={updateCheckBoxValue}
                  />
                }
                label=""
                sx={{ marginRight: 1 }}
              />
            </Mui.Grid>

            <Mui.Grid item xs={10} md>
              <Mui.Typography
                sx={{
                  fontSize: 16,
                  color: themes.headLine,
                }}
              >
                The employee will be able to submit their leaves, reimbursement
                claims, view, and generate payslips through the employee portal.
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          {checkBoxValue && (
            <Mui.Grid container sx={{ ml: 5 }}>
              <Mui.Grid item xs={1.1} sx={{ padding: 1 }}>
                <Mui.Stack direction="row">
                  <Mui.Typography
                    sx={{
                      fontSize: 16,
                      color: themes.headLine,
                      paddingBottom: 0.5,
                      fontWeight: "bold",
                    }}
                  >
                    User Group
                  </Mui.Typography>
                  &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Select the user group to define what features and permissions the employee can access when using the portal."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Stack>
              </Mui.Grid>
              <Mui.Grid item xs={0.2}>
                {" "}
              </Mui.Grid>

              <Mui.Grid item xs={2}>
                <CustomAutoComplete
                  dataList={userGroupList.map((obj) => ({
                    ...obj,
                    label: obj.name,
                  }))}
                  selectedValue={watch("usergroup_name")}
                  rules={{
                    ...register("usergroup_name", {
                      required: checkBoxValue
                        ? "User Group name is required"
                        : false,
                    }),
                  }}
                  updateDataFunction={handleUserGroupName}
                  placeHolder="Select the user group name"
                  errorMessage={
                    errors?.usergroup_name?.message
                      ? errors?.usergroup_name?.message
                      : ""
                  }
                  textBoxError={errors?.usergroup_name ? true : false}
                />
              </Mui.Grid>
            </Mui.Grid>
          )}
        </Mui.Grid>

        <Mui.Grid
          container
          sx={{
            paddingBottom: { xs: 2, sm: 4, md: 4, lg: 5, xl: 5, xxl: 5 },
          }}
        />
        <Mui.Grid container sx={{ padding: 2 }}>
          <Mui.Grid xs={2}></Mui.Grid>
          <Mui.Grid xs={8}></Mui.Grid>
          <Mui.Grid
            xs={2}
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            <CustomButton
              actionName="Create"
              typeName="submit"
              disableAction={buttonLoader}
            />
          </Mui.Grid>
        </Mui.Grid>
      </form>
      <GlobalDialogBox
        handleCloseDialog={() => {
          setOpenDialog(false);
          history.push("/admin/hrzone/employees");
        }}
        open={openDialog}
        title="Add additional Data"
      >
        <Mui.Grid container sx={{ paddingBottom: 2 }}>
          <Mui.Typography sx={{ fontSize: 20 }}>
            Would you like to add additional data?
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid
          container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <CustomButton
            actionFuntion={() => history.push("/admin/hrzone/employees")}
            actionName="No"
            typeName="button"
          />{" "}
          &nbsp; &nbsp;
          <CustomButton
            actionFuntion={() => {
              dispatch(setScreenUserId(userId));
              dispatch(setEditPage(2));
              history.push("/admin/hrzone/edit/employees");
            }}
            actionName="Yes"
            typeName="submit"
          />
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
